import PortUtils from "../portlibs/PortUtils";
import Utils from "../portlibs/PortUtils";
import { TFrequency, Currency, IPrice, PriceCols, ICompValue, ESectors, TSectorPair, isCash, isSave, isGIC, isBond, isCashEq } from "../shared/Consts"

export type { TFrequency }

export class Price implements ICompValue {
    _id:string;
    currency:number;
    price:number;
    name:string;
    payout:number;
    yield:number;
    sector:ESectors;
    frequency:TFrequency;
    date:Date;
    ex:number;
    sectors?:TSectorPair[];
    variableDividend:boolean;

    get id() { return this._id }

    // get payout(){ return this.payout ? this.payout : this.price * this.rate / 100 }
    get numDistributions(){
        switch(this.frequency){
        case "m":   return 12;
        case "s":   return 2;
        case "a":   return 1;
        default:    return 4
        }
    }
    interval(dir:number=1){
        switch(this.frequency){
        case "m":   return {month:dir}
        case "s":   return {month:6*dir}
        case "a":   return {year:dir}
        default:    return {month:3*dir}
        }
    }
    constructor(price:IPrice|Price) {
        if (price instanceof Price){
            this._id = price._id;
            this.currency = price.currency;
            this.price = price.price;
            this.name = price.name;
            this.payout = price.payout;
            this.yield = price.yield;
            this.sector = price.sector;
            this.sectors = price.sectors;
            this.date = price.date;
            this.frequency = price.frequency;
            this.ex = price.ex;
            this.variableDividend = price.variableDividend;
        }
        else {
            this._id = price._id;
            if ("currency" in price) this.currency = price.currency;
            else this.currency = (/\.TO$|\.CF$/.test(this._id) ? Currency.CAD : Currency.USD) as number

            this.price = price.price || 0
            this.name = price.name || this._id;
            this.payout = price.payout || 0;
            this.yield = price.yield ? price.yield : this.payout ? this.payout/this.price*100 : 0;
            this.sector = price.sector || ESectors.Other
            this.sectors = price.sectors;
            this.ex = price.ex || 15;
            this.date = price.date ? new Date(price.date) : new Date(0)
            this.variableDividend = price.vd || false;
            if (!this.payout && this.yield) this.payout = this.price*this.yield/100
            this.frequency = price.frequency || Utils.frequency(this._id);
        }
    }
    setDate(date:Date){
        this.date = date
        return this
    }
    setYield(yld:number){
        this.yield = this.yield = yld
        return this
    }
    setFrequency(freq:TFrequency) {
        this.frequency = freq
        return this
    }
    setEx(ex:number){
        this.ex = ex
        return this
    }
    setPayout(payout:number){
        this.payout = payout
        return this
    }
    get dates() {
        const ret : Date[] = []
        if (!this.date.getTime()) return ret

        const year = new Date().getFullYear()
        let date = new Date(year, this.date.getMonth(), this.date.getDate(), 0, 0, 0);
        const count = this.numDistributions;
        const intervalBack = this.interval(-1)
        const interval = this.interval()
        for(;;){
            const d = Utils.dateAdd(date, intervalBack)
            if (d.getFullYear()!=year) break;
            else date = d
        }

        for(let i=0; i<count*2; i++) {
            const ex = new Date(date.getTime() - this.ex*24*3600*1000);
            ret.push(ex, date)
            date = Utils.dateAdd(date, interval)
        }
        return ret
    }
    clone():Price {
        return new Price(this)
    }
    get payload() {
        return {
            [PriceCols.name] : this.name,
            [PriceCols.price] : this.price,
            [PriceCols.date] : this.date.getTime(),
            [PriceCols.yield] : this.yield,
            [PriceCols.payout] : this.payout,
            [PriceCols.exDividend] : this.ex,
            [PriceCols.variableDividend] : this.variableDividend,
            [PriceCols.frequency] : this.frequency,
            [PriceCols.currency] : this.currency,
            [PriceCols.sector] : this.sector,
            [PriceCols.sectors] : this.sectors
        }
    }
    get distributionYield(){
        switch(this.frequency){
        case "m":   return 1/12
        case "q":   return 1/4
        case "s":   return 1/2
        default:    return 1
        }
    }
    get distribution(){return this.payout*this.distributionYield}
    
    static isCash(ticker:string)                { return isCash(ticker) }
    static isSave(ticker:string|null|undefined) { return isSave(ticker) }
    static isGIC(ticker:string|null|undefined)  { return isGIC(ticker) }
    static isBond(ticker:string|null|undefined) { return isBond(ticker) }
    static isCashEq(ticker:string)              { return isCashEq(ticker) }
    className(col:string):string{
        return "";
    }
    value(col:string):string{
        switch(col){
        case PriceCols.frequency:       return Price.frequencyLabel(this.frequency)
        case PriceCols.payout:          return Utils.formatCurrency(this.currency, this.payout);
        case PriceCols.yield:           return Utils.formatNumber(this.yield) + "%"
        case PriceCols.sector:          return PortUtils.sector(this.sector)
        case PriceCols.date:            return this.date.getTime() ? Utils.formatDate("yyyy-MM-dd", this.date) : "-"
        default:    return (this as any)[col]
        }
    }
    static frequencyLabel(freq:TFrequency){
        switch(freq){
        case "m":   return "Monthly";
        case "a":   return "Annually";
        case "s":   return "Semi-Anually";
        default:    return "Quarterly";
        }
    }
    compValue(col:string){
        if (col=="name") return this.name.toLowerCase()
        else return (this as any)[col]
    }
}